import {
  createContext,
  useCallback,
  useContext,
  useMemo,
  useState,
} from "react";

import {
  createRegion,
  deleteRegionById,
  getRegionById,
  getRegionList,
  updateRegionById,
} from "./queries";

const RegionContext = createContext({});

export const useRegionContext = () => useContext(RegionContext);

export const RegionProvider = ({ ...props }) => {
  const [regionList, setRegionList] = useState([]);
  const [regionPerId, setRegionPerId] = useState({});

  const regionListGetter = useCallback(async () => {
    try {
      if (regionList?.length === 0) {
        setRegionList(await getRegionList());
      }
    } catch (e) {
      console.error("regionListGetter", e);
      throw e;
    }
  }, [regionList]);

  const regionByIdGetter = useCallback(
    async (id) => {
      try {
        setRegionPerId(await getRegionById(id));
      } catch (e) {
        console.error("regionListGetter", e);
        throw e;
      }
    },
    [setRegionPerId]
  );

  const regionCreate = useCallback(async (data) => {
    try {
      if (data.parent_id && !isNaN(data.parent_id)) {
        data.parent_id = parseInt(data.parent_id, 10);
      }
      if (!data.parent_id) {
        data.parent_id = null;
      }
      const region = await createRegion(data);
      setRegionList((old) => [...old, region]);
    } catch (e) {
      console.error("regionCreate", e);
      throw e;
    }
  }, []);

  const regionUpdateById = useCallback(async (id, data) => {
    try {
      if (data.parent_id && !isNaN(data.parent_id)) {
        data.parent_id = parseInt(data.parent_id, 10);
      }
      if (!data.parent_id) {
        data.parent_id = null;
      }
      const updatedRegion = await updateRegionById(id, data);
      setRegionPerId(updatedRegion);
      setRegionList((old) =>
        old.map((e) => (e.id === updatedRegion.id ? updatedRegion : e))
      );
    } catch (e) {
      console.error("regionUpdateById", e);
      throw e;
    }
  }, []);

  const regionDeleteById = useCallback(
    async (id) => {
      try {
        await deleteRegionById(id);
        setRegionList((old) => old.filter((row) => row.id !== id));
      } catch (e) {
        console.error("regionDelete", e);
        throw e;
      }
    },
    [setRegionList]
  );

  const values = useMemo(
    () => ({
      regionList,
      regionListGetter,
      regionByIdGetter,
      regionDeleteById,
      regionCreate,
      regionUpdateById,
      regionPerId,
      setRegionPerId,
    }),
    [
      regionList,
      regionListGetter,
      regionByIdGetter,
      regionDeleteById,
      regionCreate,
      regionUpdateById,
      regionPerId,
      setRegionPerId,
    ]
  );
  return <RegionContext.Provider value={values} {...props} />;
};
